import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DetailApplicationComponent } from './detail-application.component';

const routes: Routes = [
  { path: '', pathMatch: 'full',component: DetailApplicationComponent, },
  {
    path: 'detailitem',
    data: { breadcrumbI18nKey: 'DocDetails' },
    component: DetailApplicationComponent,
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})

export class DetailApplicationRoutingModule { }
